import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { VersionService } from "./version.service";
import { Router } from "@angular/router";

declare var $;


@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.css'],
  providers: [
    VersionService
  ]
})
export class VersionComponent implements OnInit {

  title: string;

  isLoading: boolean;
  filterParams: any;
  totalPage: number;
  appList: any;
  app: any = {};
  totalElements: number;
  modal: any = {};

  //watch variable change
  differ: any;
  constructor(
    private versionService: VersionService,
    private differs: KeyValueDiffers,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.title = "App information";
    this.filterParams = {
      size: 10,
      page: 0
    };
  }

  ngDoCheck() {
    var change = this.differ.diff(this.filterParams);
    if (change) {
      if (this.filterParams.page < 0) {
        this.filterParams.page = 0;
        return;
      } else if (this.filterParams.page > this.totalPage - 1) {
        this.filterParams.page = this.totalPage - 1;
        return;
      }
      this.getAppList();
    }
  }

  getAppList() {

    this.isLoading = true;
    this.versionService.getAppList(this.filterParams)
      .then(res => {
        if( res.status === 1 )
        {
          this.appList = res.data.dataList;
          this.totalElements = res.data.totalElements;
          this.initPaginate();
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      })
      .catch(err => console.log(err));
  }

  //init paging 
  initPaginate() {
    this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
    let arrPagingNumber = [];
    for (let i = 0; i < this.totalPage; i++) {
      arrPagingNumber.push(i);
    }
    return arrPagingNumber;
  }

  initModal(state, app: any = {}) {

    switch (state) {
      case 'create': {
        this.modal = {
          title: 'Create app',
          btnName: 'Create',
          state: state
        };
        this.app = {};
      }
        break;
      case 'edit': {
        this.modal = {
          title: 'Edit app',
          btnName: 'Save',
          state: state
        };
        this.app = app;
      }
        break;
    }
    $('#myModal').modal('show');
  }

  onSubmit(frmAppInfo) {
    this.isLoading = true;
    if (this.modal.state === 'create'){
      this.versionService.createApp(frmAppInfo.value)
      .then(res => {
        if( res.status === 1 )
        {
          this.toastr.success(res.message , 'Success!');
          this.getAppList();
          $('#myModal').modal('hide');
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      })
      .catch(err => console.log(err));
    }

    if (this.modal.state === 'edit'){
      this.versionService.editApp(frmAppInfo.value)
      .then(res => {
        if( res.status === 1 )
        {
          this.toastr.success(res.data , 'Success!');
          this.getAppList();
          $('#myModal').modal('hide');
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      })
      .catch(err => console.log(err));
    }
  }

  deleteApp(id: string){
    if(confirm("Confirm delete!")){
      this.versionService.deleteApp(id)
      .then( res => {
        if( res.status == 1){
          this.toastr.success(res.data , 'Success!');
          this.getAppList();
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
      }).catch(err => console.log(err));
    }    
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/version/version.component.ts